import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import '../sip/Calculators.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const Car = () => {
  const [buyCar, setBuyCar] = useState(10);
  const [currentCost, setCurrentCost] = useState(1000000);
  const [inflationRate, setInflationRate] = useState(6);
  const [expectedReturn, setExpectedReturn] = useState(12);
  const [results, setResults] = useState(null);
  const [pieData, setPieData] = useState(null);

  const calculateCarPlan = () => {
    const futureCost = currentCost * Math.pow(1 + inflationRate / 100, buyCar);

    // SIP Calculation
    const monthlyRate = expectedReturn / 100 / 12;
    const months = buyCar * 12;
    const sip = futureCost / (((Math.pow(1 + monthlyRate, months) - 1) / monthlyRate) * (1 + monthlyRate));

    // Lumpsum Calculation
    const lumpsum = futureCost / Math.pow(1 + expectedReturn / 100, buyCar);

    setResults({
      futureCost: Math.round(futureCost),
      sip: Math.round(sip),
      lumpsum: Math.round(lumpsum),
    });

    setPieData({
      labels: ['Planning Through SIP', 'Planning Through Lumpsum'],
      datasets: [
        {
          data: [sip, lumpsum],
          backgroundColor: ['#004aad', '#76d041'],
          borderWidth: 1,
        },
      ],
    });
  };

  return (
    <div className="sip-calculator">
      <h2>Car Planning Calculator</h2>

      <div className="input-group">
        <label>After how many years do you wish to buy your dream car?</label>
        <input
          type="range"
          min="0"
          max="40"
          value={buyCar}
          onChange={(e) => setBuyCar(Number(e.target.value))}
        />
        <input
          type="number"
          min="0"
          max="40"
          value={buyCar}
          onChange={(e) => {
            const val = e.target.value;
            setBuyCar(val === '' ? '' : Number(val));
          }}
          className="value-box"
        />
      </div>

      <div className="input-group">
        <label>Current Cost of your dream car?</label>
        <input
          type="range"
          min="100000"
          max="50000000"
          step="10000"
          value={currentCost}
          onChange={(e) => setCurrentCost(Number(e.target.value))}
        />
        <input
          type="number"
          min="100000"
          max="50000000"
          step="10000"
          value={currentCost}
          onChange={(e) => {
            const val = e.target.value;
            setCurrentCost(val === '' ? '' : Number(val));
          }}
          className="value-box"
        />
      </div>

      <div className="input-group">
        <label>Expected Inflation Rate (%)</label>
        <input
          type="range"
          min="0"
          max="15"
          step=".1"
          value={inflationRate}
          onChange={(e) => setInflationRate(Number(e.target.value))}
        />
        <input
          type="number"
          min="0"
          max="15"
          step=".1"
          value={inflationRate}
          onChange={(e) => {
            const val = e.target.value;
            setInflationRate(val === '' ? '' : Number(val));
          }}
          className="value-box"
        />
      </div>

      <div className="input-group">
        <label>Expected Returns (%)</label>
        <input
          type="range"
          min="0"
          max="20"
          step=".1"
          value={expectedReturn}
          onChange={(e) => setExpectedReturn(Number(e.target.value))}
        />
        <input
          type="number"
          min="0"
          max="20"
          step=".1"
          value={expectedReturn}
          onChange={(e) => {
            const val = e.target.value;
            setExpectedReturn(val === '' ? '' : Number(val));
          }}
          className="value-box"
        />
      </div>

      <button onClick={calculateCarPlan} className="calculate-btn">
        Calculate
      </button>

      {results && (
        <div className="sip-output-section">
          <div className="result-summary">
            <h3>Results</h3>
            <p>
              After {buyCar} Years, Your Dream Car Cost Would Be: <span>₹{results.futureCost.toLocaleString()}</span>
            </p>
            <p>
              Planning Through SIP: <span>₹{results.sip.toLocaleString()}</span>
            </p>
            <p>
              Planning Through Lumpsum: <span>₹{results.lumpsum.toLocaleString()}</span>
            </p>
          </div>

          {pieData && (
            <div className="pie-chart-container">
              <h3>SIP vs Lumpsum</h3>
              <Pie data={pieData} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Car;
